// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"396":"9cc79d4f42095ef8","731":"7958603c227debe8","888":"dc9b67a4f0db51e7","978":"0caba023a28cbeb4"}[chunkId] + ".css";
};